import { useAuth } from "@contexts/authContext";

/**
 * Whether the logged-in user's role in the selected organization has the given
 * permission (e.g. Permissions.QontactPoints.MANAGE). Returns undefined while the
 * role is still loading. The backend enforces the same permissions; this is only
 * to adapt the UI (e.g. read-only views).
 */
export const useHasPermission = (permissionID: string): boolean | undefined => {
    const { userRole } = useAuth();
    if (!userRole) {
        return undefined;
    }
    return Boolean(userRole.permissions?.some((permission) => permission.id === permissionID));
};

export default useHasPermission;
